import { ApplicationFormData } from '../../types';

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateName = (name: string): boolean => {
  const nameRegex = /^[a-zA-Z\s\-']+$/;
  return nameRegex.test(name) && name.trim().length >= 1;
};

export const validateTikTokHandle = (handle: string): boolean => {
  const tiktokRegex = /^@[a-zA-Z0-9][a-zA-Z0-9._]{1,23}$/;
  if (!tiktokRegex.test(handle)) return false;
  if (handle.includes('..')) return false;
  if (handle.endsWith('.')) return false;
  return true;
};

export const validateInstagramHandle = (handle: string): boolean => {
  const instaRegex = /^@[a-zA-Z_][a-zA-Z0-9_.]{0,29}$/;
  if (!instaRegex.test(handle)) return false;
  if (handle.includes('..')) return false;
  if (handle.endsWith('.')) return false;
  return true;
};

export const validateCity = (city: string): boolean => {
  const cityRegex = /^[a-zA-Z\s\-.']+$/;
  return cityRegex.test(city) && city.trim().length >= 2;
};

export const validatePhone = (phone: string): boolean => {
  const digitsOnly = phone.replace(/\D/g, '');
  return digitsOnly.length >= 7 && digitsOnly.length <= 15;
};

export const validateStep = (
  currentStep: number,
  formData: ApplicationFormData,
  termsAgreed: boolean,
  showToast: (message: string, type: 'error' | 'success' | 'info') => void
): boolean => {
  switch (currentStep) {
    case 0:
      if (!termsAgreed) {
        showToast('You must agree to the terms to continue.', 'error');
        return false;
      }
      return true;

    case 1:
      if (!formData.firstName || !formData.lastName || !formData.email || !formData.phone || !formData.country || !formData.city || !formData.gender) {
        showToast('Please fill in all required fields.', 'error');
        return false;
      }
      if (!validateName(formData.firstName)) {
        showToast('First name can only contain letters, spaces, hyphens, and apostrophes.', 'error');
        return false;
      }
      if (!validateName(formData.lastName)) {
        showToast('Last name can only contain letters, spaces, hyphens, and apostrophes.', 'error');
        return false;
      }
      if (!validateEmail(formData.email)) {
        showToast('Please enter a valid email address.', 'error');
        return false;
      }
      if (!validatePhone(formData.phone)) {
        showToast('Please enter a valid phone number (7-15 digits).', 'error');
        return false;
      }
      if (!validateCity(formData.city)) {
        showToast('Please enter a valid city name.', 'error');
        return false;
      }
      return true;

    case 2:
      if (!formData.tiktokHandle || !formData.instagramHandle || !formData.contentDuration || (formData.brandDeals === 'Yes' && !formData.brandsIfYes)) {
        showToast('Please fill in all required fields.', 'error');
        return false;
      }
      if (!validateTikTokHandle(formData.tiktokHandle)) {
        showToast('TikTok handle must be @username with 2-24 characters (letters, numbers, underscores, periods only).', 'error');
        return false;
      }
      if (!validateInstagramHandle(formData.instagramHandle)) {
        showToast('Instagram handle must be @username with 1-30 characters (letters, numbers, underscores, periods only).', 'error');
        return false;
      }
      return true;

    case 3:
      if (!formData.goesToGym || !formData.workoutFrequency || !formData.gymAccessForFilming || !formData.fitnessJourney) {
        showToast('Please fill in all required fields.', 'error');
        return false;
      }
      if (formData.fitnessJourney.trim().length < 20) {
        showToast('Please tell us more about your personal growth journey (at least 20 characters).', 'error');
        return false;
      }
      return true;

    case 4:
      if (!formData.videosPerWeek || !formData.weeklyCall || !formData.bestCallTimes || !formData.bestCallTimes.trim()) {
        showToast('Please fill in all required fields.', 'error');
        return false;
      }
      if (formData.bestCallTimes.trim().length < 5) {
        showToast('Please provide more detail about your available call times.', 'error');
        return false;
      }
      return true;

    default:
      return true;
  }
};
